module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "welcome"
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 12
    }
  }, [(this.pageListData.list && this.pageListData.list.length > 0) ? _vm._l((this.pageListData.list), function(item, index) {
    return _c('el-col', {
      attrs: {
        "span": 8
      },
      nativeOn: {
        "click": function($event) {
          return _vm.getInfo(item.id)
        }
      }
    }, [_c('el-card', {
      staticClass: "box-card",
      attrs: {
        "shadow": "hover"
      }
    }, [_c('div', {
      staticClass: "clearfix",
      attrs: {
        "slot": "header"
      },
      slot: "header"
    }, [(item.isNew == 1) ? _c('el-badge', {
      staticClass: "item",
      attrs: {
        "value": "new"
      }
    }, [_vm._v(_vm._s(item.tag))]) : _c('el-badge', {
      staticClass: "item"
    }, [_vm._v(_vm._s(item.tag))]), _vm._v(" "), _c('span', {
      staticStyle: {
        "float": "right"
      },
      attrs: {
        "type": "text"
      }
    }, [_vm._v(_vm._s(_vm.resolvingDate(item.createTime)))])], 1), _vm._v(" "), _c('div', {
      staticClass: "text item"
    }, [_c('h3', {
      staticClass: "jhh-notices"
    }, [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('p', {
      staticClass: "gome-shop"
    }, [_vm._v("\n              " + _vm._s(item.memo) + "\n            ")])])])], 1)
  }) : _vm._e()], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// /opt/devenv/allscs-jhh/repair-ui/~/vue-loader/lib/template-compiler?{"id":"data-v-37f5d073","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!/opt/devenv/allscs-jhh/repair-ui/~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Welcome.vue
// module id = 1642
// module chunks = 0